import React from "react";
import { partners } from "@/content/site";
import { PageHero, Section, CtaBand, FeatureCard, CardGrid } from "@/components/NovaKit";

export default function Partners() {
  return (
    <div data-testid="partners-page">
      <PageHero eyebrow={partners.eyebrow} heading={partners.heading} highlight="strategic ecosystem links" intro={partners.intro} index="08" />

      <Section eyebrow="Selected Delivery Relationships" heading="Core delivery partners" highlight="Core delivery partners" indexLabel="08.1" bg="panel">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {partners.delivery.map((p, i) => (
            <div key={p} className="grad-border grad-border-on card-hover bg-white rounded-[20px] p-8 relative min-h-[180px] flex flex-col justify-between" data-testid={`partner-delivery-${i}`}>
              <div className="mono text-[10px] tracking-[0.22em] uppercase grad-text font-bold">0{i + 1} · Delivery</div>
              <div className="display text-3xl md:text-4xl font-bold mt-10">{p}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section eyebrow="Strategic Ecosystem Direction" heading="Strategic ecosystem partners" highlight="Strategic ecosystem partners" indexLabel="08.2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {partners.strategic.map((p, i) => (
            <div key={p} className="grad-border grad-border-on card-hover bg-white rounded-[20px] p-8 relative min-h-[180px] flex flex-col justify-between" data-testid={`partner-strategic-${i}`}>
              <div className="mono text-[10px] tracking-[0.22em] uppercase grad-text font-bold">0{i + 1} · Strategic</div>
              <div className="display text-3xl md:text-4xl font-bold mt-10">{p}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section eyebrow="Why partner with Hubinall" heading="Join a coordination-led ecosystem" highlight="coordination-led" indexLabel="08.3" bg="panel">
        <CardGrid cols={3}>
          {partners.why.map(([title, body], i) => (
            <FeatureCard key={title} index={`REASON · 0${i + 1}`} title={title} body={body} featured={i === 0} />
          ))}
        </CardGrid>
      </Section>

      <CtaBand heading="Let's build coordination value together." ctas={partners.ctas} />
    </div>
  );
}
